import CityPageTemplate from "../city-template/CityPageTemplate";
import { garlandConfig } from "./data";

export default function GarlandPage() {
  return <CityPageTemplate config={garlandConfig} />;
}